import { useEffect, useRef } from 'react'
import { toast } from 'sonner'
import type { UseQueryResult } from '@tanstack/react-query'

export function useQueryErrorToast(
  queries: UseQueryResult<unknown, Error>[],
) {
  const shownErrors = useRef(new WeakSet<object>())

  useEffect(() => {
    for (const query of queries) {
      if (!query.isError || !query.error) continue

      const error = query.error

      if (shownErrors.current.has(error)) continue

      shownErrors.current.add(error)

      toast.error(
        error.message || 'İşlem sırasında bir hata oluştu.',
      )
    }
  }, [queries])
}